import app from "firebase/app";
import "firebase/auth";
import "firebase/firebase-firestore";

const config = {
  apiKey: "AIzaSyBh28uylgohCEXs0PFPu3JnKpeUPLKZ9XU",
  authDomain: "bachat-284805.firebaseapp.com",
  databaseURL: "https://bachat-284805.firebaseio.com",
  projectId: "bachat-284805",
  storageBucket: "bachat-284805.appspot.com",
  messagingSenderId: "1083224097161",
  appId: "1:1083224097161:web:bbdb23922b74bb45efe158",
  measurementId: "G-YF5HE3JZVR",
};

class Firebase {
  constructor() {
    app.initializeApp(config);
    this.auth = app.auth();
    this.db = app.firestore();
  }

  dbreturns() {
    return this.db;
  }

  login(email, password) {
    return this.auth.signInWithEmailAndPassword(email, password);
  }

  logout() {
    return this.auth.signOut();
  }

  async register(name, email, password) {
    await this.auth.createUserWithEmailAndPassword(email, password);
    return this.auth.currentUser.updateProfile({
      displayName: name,
    });
  }

  addUser(firstname, lastname, income, familymembers, username) {
    console.log("I was here");
    const data = {
      firstname,
      lastname,
      income,
      familymembers,
      username,
      uid: new Date().getTime(),
    };

    this.db
      .collection("users")
      .doc(data.uid.toString())
      .set(data)
      .then(() => {
        alert("Sucess : New User Added");
      });
  }

  addCustomer(
    name,
    age,
    email,
    phone,
    city,
    state,
    postalcode,
    lat,
    long,
    complete,
    helped
  ) {
    const data = {
      name,
      age,
      email,
      phone,
      city,
      state,
      postalcode,
      lat,
      long,
      complete,
      helped,
      uid: new Date().getTime(),
    };

    this.db
      .collection("customers")
      .doc(data.uid.toString())
      .set(data)
      .then(() => {
        alert("Sucess : New Customer Added");
      });
  }

  addComment(expense) {
    const data = {
      expense: expense.expense,
      actual: expense.actual,
      ideal: expense.ideal,
      user: expense.user,
      _id: new Date().getTime(),
    };

    this.db
      .collection("comments")
      .doc(data._id.toString())
      .set(data)
      .then(() => {
        alert("Sucess : New Comment Added");
      });
    return data;
  }

  isInitialized() {
    return new Promise((resolve) => {
      this.auth.onAuthStateChanged(resolve);
    });
  }

  getCurrentUsername() {
    return this.auth.currentUser && this.auth.currentUser.email;
  }
}

export default new Firebase();

// const onUpdate = () => {
//     const db = firebase.db;
//     db.collection("users")
//       .doc(userdetail[0].uid.toString())
//       .set({ ...userdetail[0], service: false });
//   };
//   const onUpdate2 = () => {
//     const db = firebase.db;
//     db.collection("users")
//       .doc(userdetail[0].uid.toString())
//       .set({ ...userdetail[0], service: true });
//   };



// WEBPACK FOOTER //
// ./src/firebase/base.js